import { render, staticRenderFns } from "./WHero.vue?vue&type=template&id=e2b3c4fe&scoped=true&lang=pug&"
import script from "./WHero.vue?vue&type=script&lang=js&"
export * from "./WHero.vue?vue&type=script&lang=js&"
import style0 from "./WHero.vue?vue&type=style&index=0&id=e2b3c4fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b3c4fe",
  null
  
)

export default component.exports